import { getWindowObject } from '@eventbrite/feature-detection';
import { LOCATION_CHANGE } from 'react-router-redux';
import { AnyAction, Dispatch, Store } from 'redux';
import { getOrderPersistentId } from '../selectors/order';
import { CheckoutState } from '../state';
import { UPDATE_PAGE_PROPS_EVENT_TYPE } from './constants';

type DataLayer = {
    push: (whatToPush: Object) => void;
};

type Payload = {
    pathname: String;
};

function pushPageProps(
    dataLayer: DataLayer,
    routerPayload: Payload,
    orderId: String | null,
) {
    const destinationURL =
        getWindowObject('location').origin + routerPayload.pathname;

    const page = {
        destinationURL,
        routerPayload,
        ...(orderId && { orderId }),
    };

    dataLayer?.push?.({
        event: UPDATE_PAGE_PROPS_EVENT_TYPE,
        page,
        sendToHeap: true,
    });
}

export const dataLayerMiddleware =
    (dataLayer: DataLayer) =>
    (store: Store<CheckoutState>) =>
    (next: Dispatch<CheckoutState>) =>
    (action: AnyAction) => {
        const state = store?.getState();
        const orderId = getOrderPersistentId(state);
        const { type, payload } = action;

        if (
            type == LOCATION_CHANGE &&
            payload?.pathname &&
            payload.pathname !== '/'
        ) {
            pushPageProps(dataLayer, payload, orderId);
        }

        return next(action);
    };
